export function Next({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 23 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.94641 6.61793V15.3904C3.94641 17.1871 5.8989 18.3146 7.45723 17.4163L11.2614 15.2254L15.0656 13.0254C16.6239 12.1271 16.6239 9.88125 15.0656 8.98292L11.2614 6.78293L7.45723 4.59211C5.8989 3.69377 3.94641 4.8121 3.94641 6.61793Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.0535 16.6649V5.33496"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
